<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">Object Count</h3>
    <div class="header-actions">
      <i class="fa fa-times" style="cursor: pointer" (click)="close()"></i>
    </div>
  </div>
  <div class="modal-body">
    @if (dataLoading) {
<div class="obj-cnt-loader-container flex-center">
      <i class="fa fa-spinner fa-spin obj-cnt-loader gtw-red"></i>
      <span>Loading...</span>
    </div>
}
    @if (!dataLoading) {

      @if (simpleLayout) {
<div class="simple-layout-container">
        <span>{{ data.tableName }}:</span>
        <span>{{ objectDataCount[0]?.group_obj_key }}</span>
        <span>{{ objectDataCount[0]?.cnt }}</span>
      </div>
}
      @if (!simpleLayout) {
<div class="center-block">
        <div class="text-center">
          <span class="obj-name">{{ data.tableName }}</span>
        </div>
        <hr />
        @if (objectDataCount.length === 0) {
<div class="no-data-msg text-center">
          <span>Oops, we didn't find any objects for this table.</span>
        </div>
}
        @if (objectDataCount.length > 0) {
<div class="obj-cnt-table-wrapper">
          <table class="obj-cnt-table">
            <thead>
              <tr>
                @if (displayTaxYear) {
<th class="text-center">Tax Year</th>
}
                <th class="text-center">Group Object Key</th>
                <th class="text-center">No. Objects</th>
              </tr>
            </thead>
            <tbody>
              @for (row of objectDataCount; track $index) {
<tr>
                @if (displayTaxYear) {
<td class="text-center">{{ row.tax_year }}</td>
}
                <td class="text-center">{{ row.group_obj_key }}</td>
                <td class="text-center">{{ row.cnt }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
}
    
}
  </div>
</div>
